import { catchError } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Gestor } from '../models/gestor.model';
import { Eleicao } from '../models/eleicao.model';
import { GestorComponent } from '../pages/gestor/gestor.component';
import { GestorDTO } from '../models/gestorDTO.model';
import { ResultadosEleicao } from '../models/resultadosEleicao.model';
import { VotosEleicao } from '../models/votosEleicao.model';
import { Logins } from '../models/logins.model';
import { AssistenteDTO } from '../models/assistenteDTO.model';
import { RelatorioEmail } from '../models/relatorioEmail.model';

@Injectable({
  providedIn: 'root'
})
export class GestoresService {

  private configHeader: any;
  private configBody: any;

  constructor(
    private http: HttpClient
  ) { }

  buscarTodosGestores(token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/gestores`, this.configHeader)
          .subscribe(
            payload => {
              if (payload) {
                resolve(payload)
              } else {
                reject(payload);
              }
            },
            error => {
              reject(error.message);
            }
          );
    })
  }
  public buscarEleicaoPorIdGestor(tokenParam: any, idGestor: number) {
    return new Promise((resolve, reject) => {
      var token = `${tokenParam}`;
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<Gestor>(`${environment.url_api}/eleicoes/by-gestor?idGestor=${idGestor}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    }
    )
  }

  public buscarAssistentesPorIdGestor(tokenParam: any, idGestor: number) {
    return new Promise((resolve, reject) => {
      var token = `${tokenParam}`;
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<Gestor>(`${environment.url_api}/assistentes/by-gestor?idGestor=${idGestor}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    }
    )
  }
  
  public alterarGestor(tokenParam: any, idGestor: number, ativo: boolean) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.put(`${environment.url_api}/gestores/${idGestor}/change-status?status=${ativo}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }
  public alterarAssistente(tokenParam: any, idAssistente: number, ativo: boolean) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.put(`${environment.url_api}/assistentes/${idAssistente}/change-status?status=${ativo}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }
  public alterarSenhaGestor(tokenParam: any, idGestor: number, senha: string) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.put(`${environment.url_api}/gestores/${idGestor}/change-password?password=${senha}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }
  public alterarSenhaAssistente(tokenParam: any, idAssistente: number, senha: string) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.put(`${environment.url_api}/assistentes/${idAssistente}/change-password?password=${senha}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }
  public salvarNovoGestor(tokenParam: any, gestor: GestorDTO) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.post(`${environment.url_api}/gestores`, gestor, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    });
  }

  public salvarNovoAssistente(tokenParam: any, assistente: AssistenteDTO) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.post(`${environment.url_api}/assistentes`, assistente, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    });
  }

  public alterarStatusEleicao(tokenParam: any, idEleicao: any, status: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } };
      this.http.put<Gestor>(`${environment.url_api}/eleicoes/change-status?eleicaoId=${idEleicao}&status=${status}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
      )
    })

  }

  public buscarZereseima(tokenParam: any, idEleicao: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.get(`${environment.url_api}/votos/buscar-zeresima?eleicaoId=${idEleicao}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    });
  }

  public inserirZeresima(tokenParam: any, idEleicao: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.post(`${environment.url_api}/votos/zeresima?eleicaoId=${idEleicao}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    });
  }

  public apurarResultadoDaEleicao(token: any, idEleicao: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post<Eleicao>(`${environment.url_api}/eleicoes/${idEleicao}/gerarResultados`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    });
  }

  public retornaResultadoPorIdEleicao(token: any, idEleicao: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/eleicoes/${idEleicao}/resultado`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    }
    );
  }

  public getPreviewKey(tokenParam: any, idGestor: number) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.get(`${environment.url_api}/gestores/key/${idGestor}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public getExecInicioEleicaoAuto (tokenParam: any){

    return new Promise((resolve,reject)=>{
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.get(`${environment.url_api}/eleicoes/execInicio`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public getAllLogsAcessoByIdEleicao(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<Logins>(`${environment.url_api}/eleicoes/${idEleicao}/logsAcesso`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }

  public getRelatorioVotos(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<VotosEleicao>(`${environment.url_api}/gestores/${idEleicao}/relatorioVotos`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }

  public getRelatorioEmails(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<RelatorioEmail>(`${environment.url_api}/gestores/${idEleicao}/relatorioEmail`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }

  public getRelatorioEmailDetalhado(idEleicao: number, token: any, idEmail: number) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<RelatorioEmail>(`${environment.url_api}/gestores/${idEleicao}/relatorioEmailDetalhado?idEmail=${idEmail}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }

  public gerarCandidatos(token: any, idEleicao: any, idGestor: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post<Eleicao>(`${environment.url_api}/eleicoes/${idEleicao}/gerarCandidatos?idGestor=${idGestor}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    });
  }

}
